var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal fade",attrs:{"data-keyboard":"false","data-backdrop":"true"}},[_c('div',{class:[`modal-${_vm.props.size || 'md'}`, 'modal-dialog modal-dialog-centered']},[(_vm.modal)?_c(_vm.modal,_vm._g(_vm._b({tag:"component"},'component',_vm.props,false),_vm.listeners)):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }